import React, { useState } from "react";
import "./Navbar.css";
import logo from "./images/Logo_image.png";
import { Link } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";

function Navbar() {
  const [state, setState] = useState(false);

  function HandleClick(){
    setState(!state);
  }

  const isState = {
    display: "none"
  }

  return (
    <div className="navbar main">
      <div>
        <Link to={"/"}>
          <img className="logo" src={logo} alt="" />
        </Link>
      </div>

      <div className="menu" onClick={HandleClick}>
        <MenuIcon />
      </div>

      <div className="nav-items" style={state ? {} : isState }>
        <Link to={"/"}>
          <p>Home</p>
        </Link>
        <Link to={"/about"}>
          <p>Who we are</p>
        </Link>
        <Link to={"/activities"}>
          <p>Activities</p>
        </Link>
        <Link to={"/gallery"}>
          <p>Gallery</p>
        </Link>
        <Link to={"/contact"}>
          <p>Get In Touch</p>
        </Link>
      </div>

      <div className="second-links">
        <Link to={"/"}>
          <p>Home</p>
        </Link>
        <Link to={"/about"}>
          <p>Who we are</p>
        </Link>
        <Link to={"/activities"}>
          <p>Activities</p>
        </Link>
        <Link to={"/gallery"}>
          <p>Gallery</p>
        </Link>
        <Link to={"/contact"}>
          <p>Get In Touch</p>
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
